import $ from 'jquery';
import slick from 'slick-carousel';

function slider()
{
    /**
     * Articles Miniatures slider
     */
    const sliderArticlesMiniatures = function() {
        const node = $('.slider-articles-miniatures');

        if (node) {
            node.slick({
                adaptiveHeight: true,
                arrows: true,
                autoplay: false,
                dots: false,
                easing: 'easeOutExpo',
                infinite: true,
                slidesToScroll: 1,
                slidesToShow: 3,
                speed: 400,
                variableWidth: false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToScroll: 1,
                            slidesToShow: 1,
                        },
                    },
                ],
            });
        }
    }

    sliderArticlesMiniatures();

    /**
     * Homepage main slider.
     */
    const sliderHomepage = function() {
        const node = $('.slider-homepage');

        if (node) {
            node.slick({
                responsive: [
                    {
                        breakpoint: 999999,
                        settings: {
                            adaptiveHeight: false,
                            appendDots: $('.dots'),
                            arrows: false,
                            autoplay: true,
                            autoplaySpeed: 4000,
                            dots: true,
                            easing: 'easeOutExpo',
                            infinite: true,
                            slidesToScroll: 1,
                            slidesToShow: 1,
                            speed: 400,
                            variableWidth: false,
                        }
                    }
                ],
            });
        }
    }

    sliderHomepage();

    /**
     * Slider gallery big.
     */
    const sliderGalleryBig = function() {
        const node = $('.slider-gallery-big');

        if (node) {
            node.slick({
                // 3, then 2, then 1.
                responsive: [
                    {
                        breakpoint: 999999,
                        settings: {
                            arrows: true,
                            autoplay: false,
                            dots: false,
                            easing: 'easeOutExpo',
                            infinite: true,
                            slidesToScroll: 1,
                            slidesToShow: 3,
                            speed: 400,
                            variableWidth: false,
                        }
                    },
                    {
                        breakpoint: 1201,
                        settings: {
                            arrows: true,
                            autoplay: false,
                            dots: false,
                            easing: 'easeOutExpo',
                            infinite: true,
                            slidesToScroll: 1,
                            slidesToShow: 2,
                            speed: 400,
                            variableWidth: false,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            adaptiveHeight: false,
                            arrows: true,
                            autoplay: false,
                            dots: false,
                            easing: 'easeOutExpo',
                            infinite: true,
                            slidesToScroll: 1,
                            slidesToShow: 1,
                            speed: 400,
                            variableWidth: false,
                        },
                    },
                ],
            });
        }
    }

    sliderGalleryBig();

    /**
     * Slider gallery medium.
     */
    const sliderGalleryMedium = function() {
        const nodes = [$('.slider-gallery-medium'), $('.error404 .products-loop')];

        nodes.forEach((node) => {
            node.slick({
                // 4, then 3, then 2, then 1.
                responsive: [
                    {
                        breakpoint: 999999,
                        settings: {
                            arrows: true,
                            autoplay: false,
                            dots: false,
                            easing: 'easeOutExpo',
                            infinite: true,
                            slidesToScroll: 1,
                            slidesToShow: 4,
                            speed: 400,
                            variableWidth: false,
                        }
                    },
                    {
                        breakpoint: 1201,
                        settings: {
                            arrows: true,
                            autoplay: false,
                            dots: false,
                            easing: 'easeOutExpo',
                            infinite: true,
                            slidesToScroll: 1,
                            slidesToShow: 3,
                            speed: 400,
                            variableWidth: false,
                        },
                    },
                    {
                        breakpoint: 941,
                        settings: {
                            arrows: true,
                            autoplay: false,
                            dots: false,
                            easing: 'easeOutExpo',
                            infinite: true,
                            slidesToScroll: 1,
                            slidesToShow: 2,
                            speed: 400,
                            variableWidth: false,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            adaptiveHeight: false,
                            arrows: true,
                            autoplay: false,
                            dots: false,
                            easing: 'easeOutExpo',
                            infinite: true,
                            slidesToScroll: 1,
                            slidesToShow: 1,
                            speed: 400,
                            variableWidth: false,
                        },
                    },
                ],
            });
        });
    }

    sliderGalleryMedium();

    /**
     * Slider infos
     */
    const sliderInfos = function() {
        const node = $('.slider-infos');

        if (node) {
            node.slick({
                // 2, then 1
                responsive: [
                    {
                        breakpoint: 999999,
                        settings: {
                            slidesToScroll: 1,
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToScroll: 1,
                            slidesToShow: 1,
                        }
                    },
                ],
            });
        }
    }

    sliderInfos();

    /**
     * Slider social
     */
    const sliderSocial = function() {
        const node = $('.slider-social');

        if (node) {
            node.slick({
                responsive: [
                    {
                        breakpoint: 999999,
                        settings: {
                            adaptiveHeight: true,
                            arrows: true,
                            dots: false,
                            easing: 'easeOutExpo',
                            infinite: true,
                            slidesToScroll: 1,
                            slidesToShow: 1,
                            speed: 400,
                            variableWidth: false,
                        },
                    },
                ],
            });
        }
    }

    sliderSocial();

    // Don't know why, but in order to make events listeners work we need this.
    jQuery(function ($) {
        /**
         * Slider product gallery
         */
        const sliderProductGallery = function () {
            const initSliderProductGallery = function () {
                console.log('initSliderProductGallery');
                const node = $('#product-gallery-desktop .woocommerce-product-gallery ol');

                if (node) {
                    node.slick({
                        responsive: [
                            {
                                breakpoint: 999999,
                                settings: {
                                    arrows: true,
                                    autoplay: false,
                                    dots: false,
                                    easing: 'easeOutExpo',
                                    infinite: false,
                                    slidesToScroll: 3,
                                    slidesToShow: 3,
                                    speed: 400,
                                    variableWidth: false,
                                },
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    arrows: true,
                                    autoplay: false,
                                    dots: false,
                                    easing: 'easeOutExpo',
                                    infinite: false,
                                    slidesToScroll: 2,
                                    slidesToShow: 2,
                                    speed: 400,
                                    variableWidth: false,
                                }
                            },
                        ],
                    });
                }
            }

            const form = $('form.variations_form');

            if (form) {
                initSliderProductGallery();

                let t = null;

                $('form.variations_form').on('wc_additional_variation_images_frontend_image_swap_done_callback', () => {
                    // Need to use timeout here as when the event is triggered, the actual DOM changes
                    // are not yet done and the node isn't added in the DOM yet. We also need to keep the
                    // timer as the event is fired multiple times, thanks bad plugin.
                    if (t) clearTimeout(t);

                    t = setTimeout(initSliderProductGallery, 100);
                });
            }
        }

        sliderProductGallery();
    });
}

export { slider };
